import { Global, useMantineTheme } from '@mantine/core';

import {
  getTextStyles,
  getThemeClasses,
  getTypographyStyles,
} from './themeConfig';
import bgChecks from '../assets/bgChecks.svg';

const GlobalStyles = () => {
  const theme = useMantineTheme();
  const { colors } = theme.other;
  const isDarkMode = theme.colorScheme === 'dark';
  return (
    <Global
      styles={() => ({
        "*, *::before, *::after": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          textDecoration: "none",
        },
        body: {
          color: colors.fg.default,
        },
        ".center": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        },
        ".cardTitle": {
          color: colors.fg.default,
          ...getTypographyStyles("heading_md_semibold"),
        },
        ".subtleButton": {
          "&:hover": {
            backgroundColor: colors.primary.muted,
          },
        },
        ".fullWidth": {
          width: "100%",
        },
        html: {
          scrollBehavior: "smooth",
          // '--gradient-color-1': '#E99D3E',
          // '--gradient-color-2': '#65B0F2',
          // '--gradient-color-3': '#6431FD',
          // '--gradient-color-4': '#AC5EA6',
        },
        ".heading": {
          fontWeight: 500,
          fontSize: "24px",
          lineHeight: "31px",
        },
        "input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none",
        },
        "input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none",
        },
        "#gradient-canvas": {
          width: "100%",
          height: "100%",
          "--gradient-color-1": "#E99D3E",
          "--gradient-color-2": "#65B0F2",
          "--gradient-color-3": "#6431FD",
          "--gradient-color-4": "#AC5EA6",
        },
        "div[id^='parentdigio']": {
          overflow: "hidden !important",
          zIndex: 999999,
          background: "#ffffff",
          textAlign: "center",
          width: "468px !important",
          minHeight: "540px !important",
          height: "600px !important",
          position: "fixed",
          top: "54% !important",
          left: "50% !important",
          transform: "translate(-50%, -50%)",
          borderRadius: "12px",
          border: `1px solid ${colors.disabled.muted}`,
          // eslint-disable-next-line react/destructuring-assignment
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            width: "100%",
            height: "100%",
            background: "#ffffff",
            padding: "54px 20px",
            left: "0px",
            top: "0px",
            minHeight: "0px",
            transform: "translate(0%, 0%)",
            borderRadius: "0px",
          },
        },
        "div[id^='wrapperdigio']": {
          width: "468px",
          height: "600px",
          position: "initial",
          "& iframe": {
            width: "100%",
            height: "100%",
            border: "none",
          },
          "& img": {},
          "& > span": {
            display: "none",
          },
          // eslint-disable-next-line react/destructuring-assignment
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            width: "100%",
            height: "100%",
            backgroundColor: "#ffffff",
          },
        },
        // Mantine Notification Styles
        ".mantine-Notification-root": {
          minHeight: 60,
          background: colors.base.white,
          borderTop: `1px solid ${colors.disabled.muted}`,
          borderBottom: `1px solid ${colors.disabled.muted}`,
          borderRight: `1px solid ${colors.disabled.muted}`,
          boxShadow:
            "0px -2px 8px -4px rgba(16, 24, 40, 0.04), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
          borderRadius: 4,
          marginBottom: "-3.4rem",
          maxHeight: "fit-content",
          transitionDuration: "350ms",
          marginLeft: "auto",
          marginRight: "auto",
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            top: -8,
            left: -8,
            width: "calc(100% + 16px)",
          },
        },
        //  icon wrapper
        ".mantine-1hmlz5i , .mantine-150n7gq, , .mantine-kc9f56": {
          backgroundColor: isDarkMode ? "" : "unset",
          marginLeft: 8,
          marginRight: 8,
        },
        // success toast
        ".mantine-prmzwd , .mantine-wf9ca6": {
          borderLeft: `8px solid ${colors.primary.default}`,
        },
        // error toast
        ".mantine-172l8p9 , .mantine-1c1aba4 ": {
          borderLeft: `8px solid ${colors.error.default}`,
        },
        // warning toast
        ".mantine-1d2gjnz, .mantine-1m5yr4c": {
          borderLeft: `8px solid ${colors.warning.default}`,
        },
        // title and message
        ".mantine-Notification-title": {
          ...getTypographyStyles("content_md_medium"),
          marginBottom: 0,
        },
        ".mantine-Notification-description": {
          ...getTypographyStyles("content_sm_regular"),
        },

        // ".mantine-14zcsvh": {
        ".mantine-yrcon9": {
          bottom: "18%",
        },
        // poping out top 2 notification
        ".mantine-Notification-root:nth-last-of-type(2)": {
          marginBottom: 0,
          width: "102%",
          right: "4px",
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            width: "calc(100% + 16px)",
          },
        },
        ".mantine-Notification-root:nth-last-of-type(1)": {
          width: "102%",
          right: "4px",
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            width: "calc(100% + 16px)",
          },
        },
        ".mantine-Notification-closeButton": {
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            marginRight: 16,
          },
        },
        // Mantine Drawer Styles
        ".mantine-Paper-root": {
          height: "auto",
          maxHeight: "100%",
          padding: 16,
        },
        ".tabler-icon-pennant-filled": {
          color: theme.other.colors.primaryOld,
        },
        // Typography
        ...getTextStyles(),
        // Colors
        ...getThemeClasses(theme),

        // // New
        ".pageWrapper": {
          height: `calc(100vh - ${theme.other.navHeight}px)`,
          display: "flex",
          justifyContent: "center",
          backgroundImage: `url(${bgChecks})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          alignItems: "center",
          background: colors.bg.default,
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            // height: `calc(100vh - ${theme.other.navHeightMobile}px)`,
            // height: 'calc(100vh - 54px)',
            height: "100%",
            position: "fixed",
          },
        },
        // From common styles
        ".csMainContainer": {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          color: colors.fg.default,
          paddingTop: "44px",
          position: "relative",
          borderRadius: "12px",
          // [`@media (max-width: ${theme.breakpoints.xs})`]: {
          //   paddingTop: 0,
          // },
        },
        ".csHeader": {
          width: "100%",
          height: "100%",
          maxHeight: "54px",
          padding: "12px 20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "-44px",
          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            // display: 'none',
            paddingBottom: 0,
          },
        },
        ".csProgressWrapper": {
          width: "100%",
          height: "100%",
          maxHeight: "16px",
          display: "flex",
          alignItems: "center",
        },
        ".csHeaderText": {
          fontWeight: 700,
          fontSize: "16px",
          lineHeight: "21px",
          color: theme.other.colors.primaryText,
        },
        ".csContentContainer": {
          padding: "20px",
          paddingTop: 0,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          [`@media (max-width: ${theme.breakpoints.xs})`]: {},
        },
        ".csFooter": {
          display: "flex",
          justifyContent: "flex-end",
          padding: "18px 20px",
          width: "100%",
          minHeight: 72,
          alignItems: "center",
          boxShadow: "0px -1px 6px 0px rgba(122, 122, 122, 0.08);",

          [`@media (max-width: ${theme.breakpoints.xs})`]: {
            position: "static",
            padding: "14px 20px",
          },
        },
        ".csHeading": {
          marginTop: "8px",
          marginBottom: "8px",
          ...getTypographyStyles("heading_md_semibold"),
        },
        ".csDescription": {
          ...getTypographyStyles("content_sm_regular"),
          color: colors.primary.default,
          marginBottom: "32px",
        },
        ".csButton": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "8px",
          paddingLeft: "24px",
          width: "auto",
          background: theme.other.colors.primaryOld,
          borderRadius: "5px",
          border: "none",
          color: "#ffffff",
          ":hover": {
            cursor: "pointer",
            background: `${theme.other.colors.primaryHover} !important`,
          },
        },
        ".csIconNextButton": {
          padding: "4px 12px 4px 12px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: theme.other.colors.primaryOld,
          borderRadius: "8px",
          "&:disabled": {
            backgroundColor: theme.colors.grey[7],
          },
          ":hover": {
            backgroundColor: `${theme.other.colors.primaryHover} !important`,
          },
        },
        ".csButtonSecondary": {
          background: theme.other.colors.backgroundLight,
          border: `1px solid ${theme.other.colors.primaryOld}`,
          color: "#ffffff",
          ":hover": {
            cursor: "pointer",
            background: `${theme.other.colors.primaryHover} !important`,
          },
        },
        "::-webkit-scrollbar": {
          width: "4px",
          backgroundColor: colors.bg.muted,
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: colors.disabled.subtle,
          borderRadius: "4px",
        },
        // pan card screen faster button
        ".mantine-1v7s5f8 , .mantine-52vjzp": {
          "& .mantine-TextInput-rightSection": {
            right: 25,
          },
        },
      })}
    />
  );
};

export default GlobalStyles;
